// import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";

// const AutoLogout = ({ onLogout }) => {
//   const { userData } = useSelector((state) => state.masterData);
//   const [lastActivity, setLastActivity] = useState(Date.now());
//   const inactivityLimit = 1 * 60 * 1000; // 15 minutes

//   useEffect(() => {
//     if (userData.roleDisplayName !== "User") return;

//     // One tab updates lastActivity in localStorage
//     const updateActivity = () => {
//       const now = Date.now();
//       setLastActivity(now);
//       localStorage.setItem("lastActivity", now);
//     };

//     const events = ["mousemove", "keydown", "click"];
//     events.forEach((ev) =>
//       window.addEventListener(ev, updateActivity, { passive: true })
//     );

//     // Periodically check inactivity
//     const intervalId = setInterval(() => {
//       const stored = parseInt(localStorage.getItem("lastActivity") || `${lastActivity}`, 10);
//       const diff = Date.now() - stored;
//       if (diff > inactivityLimit) {
//         onLogout();
//       } else {
//         setLastActivity(stored);
//       }
//     }, 1000);

//     // Before closing the tab, trigger logout
//     const handleBeforeUnload = () => {
//       onLogout();
//     };
//     window.addEventListener("beforeunload", handleBeforeUnload);

//     return () => {
//       events.forEach((ev) =>
//         window.removeEventListener(ev, updateActivity)
//       );
//       clearInterval(intervalId);
//       window.removeEventListener("beforeunload", handleBeforeUnload);
//     };
//   }, [userData.roleDisplayName, onLogout, lastActivity]);

//   return null;
// };

// export default AutoLogout;


import { useEffect, useRef } from "react";

const AUTO_LOGOUT_TIME = 8 * 60 * 60 * 1000; // 8 hours

const AutoLogout = ({ onLogout, isAuthenticated }) => {
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      onLogout();
    }, AUTO_LOGOUT_TIME);
  };

  useEffect(() => {
    if (!isAuthenticated) return;

    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "scroll",
      "touchstart"
    ];

    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); // start timer when component mounts

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [isAuthenticated]);

  return null;
};

export default AutoLogout;
